export const SIGN_IN = '/sign-in';
export const SIGN_UP = '/sign-up';
export const SERIES = '/series';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/forgot-password';
export const HOME = '/';
export const ANALYTICS = '/analytics';
export const CREATE_SERIES = '/create-series';
export const UPGRADE_PLAN = '/upgrade-plan';
export const LINK_SOCIAL_ACCOUNTS = '/link-accounts';
export const VERIFY_ACCOUNT = '/verify';
export const AUTH_CALL_BACK = '/auth/callback';
// export const ROOT_API_URL = 'http://localhost:8047/';
export const ROOT_API_URL = 'https://api.fastshorts.app/';
export const API_URL = `${ROOT_API_URL}v1/`;
const AUTH_URL = `${API_URL}auth/`;
export const SIGN_UP_API = `${AUTH_URL}sign-up`;
export const GOOGLE_AUTH_API = `${AUTH_URL}google`;
export const TIKTOK_AUTH_API = `${AUTH_URL}tiktok`;
export const INSTAGRAM_AUTH_API = `${API_URL}auth/instagram`;
export const SIGN_IN_API = `${AUTH_URL}sign-in`;
export const VERIFY_API = `${API_URL}verification`;
export const RESEND_VERIFY_CODE_API = `${API_URL}verification/request`;
export const GENERATE_SERIES = `${API_URL}series`;
export const GET_THEMES = `${API_URL}theme`;
export const VIDEO_URL = `${API_URL}video/`;
export const GET_SHORTS_GENERATED = `${VIDEO_URL}generated-video-count`;
export const IG_VIDEOS = `${VIDEO_URL}all/ig`;
export const ALL_VIDEOS = `${API_URL}videos/all`;
export const PUBLISH_VIDEO = VIDEO_URL;
export const FORGOT_PASSWEOD = `${AUTH_URL}forgot-password`;
const USER_URL = `${API_URL}user/`;
export const CHECK_LINKED_ACCOUNTS = `${USER_URL}check-linked-accounts`;
export const GET_USER_TIKTOK_INFO = `${USER_URL}tiktok-info`;
export const GET_USER_YOUTUBE_INFO = `${USER_URL}youtube-info`;
export const GET_USER_INSTAGRAM_INFO = `${USER_URL}instagram-info`;
export const GET_PLANS = `${API_URL}plans`;
export const GET_SERIES = `${API_URL}series`;
export const EDIT_SERIES = `${API_URL}series`;
export const GET_VIDEOS = `${API_URL}videos`;
export const UPLOAD_TO_YOUTUBE = `${VIDEO_URL}youtube`;
export const UPLOAD_TO_INSTAGRAM = `${VIDEO_URL}instagram`;
export const UPLOAD_TO_TIKTOK = `${VIDEO_URL}tiktok`;
export const DELETE_VIDEO = VIDEO_URL;
export const ACTION_SERIES = `${API_URL}series/`;
export const make_payment = `${API_URL}payment`;
export const GET_ACTIVE_SERIES = `${API_URL}series/active`;
export const GET_VOICES = `${API_URL}voice`;
export const GET_USER = `${USER_URL}`;
